export default "__VITE_ASSET__DasZKxcV__"